module.exports = __webpack_public_path__ + "img/Arab11.17b4b3cb.jpg";